// Action types for saving data
export const SAVE_STORE_REQUEST = 'SAVE_STORE_REQUEST';
export const SAVE_STORE_SUCCESS = 'SAVE_STORE_SUCCESS';
export const SAVE_STORE_FAILURE = 'SAVE_STORE_FAILURE';
export const SAVE_STORE_RESET = 'SAVE_STORE_RESET';
// Save data actions
export const saveStoreDataRequest = (payload) => ({
    type: SAVE_STORE_REQUEST,
    payload
});
export const saveStoreDataSuccess = (payload) => ({
    type: SAVE_STORE_SUCCESS,
    payload,
});
export const saveStoreDataFailure = (error) => ({
    type: SAVE_STORE_FAILURE,
    payload: error,
});
export const saveStoreDataReset = () => ({
    type: SAVE_STORE_RESET,
});
